import React, {  useState, useRef, useEffect } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { FileUpload } from "primereact/fileupload";
import { TabPanel, TabView } from "primereact/tabview";
import { InputTextarea } from "primereact/inputtextarea";

// ------------------ COMPONENTES DE BASE --------------------------------
import { useForm } from "../../../../../../Base/Hooks/useForm";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { downloadFile, uploadHandler, } from "../../../../../../Base/Services/ArchivosService";
import { getListadoArchivos, descargarArchivo, eliminarArchivo, getLinks, guardarLink, eliminarLink } from "../../../../../../Base/API/IT/Archivos/ArchivosRequest"; 

// ------------------- CONSULTAS A LA API --------------------------------

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import "./ArchivosRequisicion.scss";

const ArchivosRequisicion = ({
  IdPurchaseRequest,
  PurchaseRequest,
  botonReporteHabilitado,
  habilitar,
}) => {
  // Variables de referencia
  const toast = useRef(null);
  const fileUpload = useRef(null);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [modalArchivo, setModalArchivo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [links, setLinks] = useState();

  const getInfo = async () => {
    setLoading(true);
    if (IdPurchaseRequest > 0) {
      const archivo = await getListadoArchivos(PurchaseRequest);
      setListadoArchivos(archivo);
      const enlace = await getLinks(IdPurchaseRequest);
      setLinks(enlace);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const referencia = {
    IdRef: IdPurchaseRequest,
    Codigo: PurchaseRequest,
  };

  const subirArchivo = async (e) => {
    if (IdPurchaseRequest > 0) {
      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandler({ e, inputs, toast, ref: fileUpload, getArchivos });

      getArchivos();
    } else {
      toastShow(toast, "warn", "Advertencia", "Debe seleccionar una Requisa.");
    }
  };

  const getArchivos = async () => {
    if (IdPurchaseRequest > 0) {
      const archivo = await getListadoArchivos(PurchaseRequest);
      setListadoArchivos(Array.isArray(archivo) ? archivo : []);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (PurchaseRequest) {
      getArchivos();
    }
  }, [PurchaseRequest]);

  useEffect(() => {
    getArchivos();
  }, []);

  const getArchivo = async (nombre) => {
    const a = await descargarArchivo(PurchaseRequest, nombre);
    downloadFile(a, nombre);
  };

  const eliminar = async (nombre) => {
    const a = await eliminarArchivo(PurchaseRequest, nombre);
    toastShow(
      toast,
      "success",
      "Cancelado",
      "Archivo de requisa eliminado correctamente."
    );
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
  };

  const openNew = () => {
    if (IdPurchaseRequest > 0) {
      let idRequisa = IdPurchaseRequest;
      setModalArchivo(true);
      getInfo(idRequisa);
    } else if(toast.current) {
      toastShow(toast, "warn", "Advertencia", "Debe seleccionar una Requisa.");
    }
  };

  const hideDialog = () => {
    setModalArchivo(false);
  };

  const handleDelete = async (IdLink) => {
    const respuesta = await eliminarLink(IdLink)
    toastShow(toast, "success","Eliminado", "Link Eliminado Correctamente");
    getInfo();
  };


  const initialValues = {
    IdLink: -1,
    Link: "",
    Description: "",
    IdPurchaseRequest: IdPurchaseRequest,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const verificarInfo = () => {
    let error = {};
    if (!values.Link) {
      error.Link = true;
      error.error = true;
    }
    setError(error);
    setLoading(false)
    return error;
  };


  const agregarLink = async () => {
    const e = verificarInfo();
    if (!e.error) {
      setLoading(true)
      const a = {
        IdLink: values?.IdLink,
        Link: values?.Link,
        Description: values?.Description,
        IdPurchaseRequest: IdPurchaseRequest,
      };
      const resultado = await guardarLink(a);
      if(resultado[0]?.ESTADO === 1){
        toastShow(toast, "success","Agregado", resultado[0]?.MENSAJE);
        setLinks([...links, a]);
        setTimeout(() => {
          setLoading(false);
          getInfo();
          onHide();
        }, 1000);
      }else{
        toastShow(toast, "error", "Error",resultado[0]?.MENSAJE);
        setLoading(false)
      }
    }
  };

  
  const onHide = () => {
    setValues(initialValues); // Restablece los valores del formulario a sus valores iniciales
    setError({}); // Limpia los errores del formulario
    setModalArchivo(false); // Cierra el modal
  };

  const DialogFooter = (
    <div style={{ textAlign: "right" }}>
      <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onHide}/>
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarLink();
        }}
      />
    </div>
  );

  return (
    <div id={"modalArchivosRequisa"}>
      <Toast ref={toast} />
      <Button
        type="button"
        icon="pi pi-folder-open"
        className="encabezado__herramienta-botones"
        tooltip="Adjuntos"
        tooltipOptions={{ className: "purple-tooltip", position: "top" }}
        style={{}}
        onClick={openNew}
        disabled={habilitar}
      />
      <Dialog
        className="modal__contenedor"
        visible={modalArchivo}
        position="top"
        modal
        onHide={() => hideDialog("displayPosition")}
        resizable={false}
        closable={true}
      >
        <Loader loading={loading} />
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="Agregar Archivos">
            <div style={{ height: "50vh", width: "60vh" }}>
              <FileUpload
                ref={fileUpload}
                name="demo"
                url="./upload"
                multiple
                customUpload
                uploadHandler={subirArchivo}
              />
              <div className="mt-3">
                <div>
                  {listadoArchivos?.map((a, i) => (
                    <div
                      className="d-flex gap p-2 border mt-2"
                      style={{ alignItems: "center" }}
                      key={i}
                    >
                      <div className="col-10">{a}</div>
                      <Button
                        icon="pi pi-download"
                        onClick={() => getArchivo(a)}
                      />
                      <Button
                        icon="pi pi-trash"
                        severity="danger"
                        onClick={() => eliminar(a)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </TabPanel>

          <TabPanel header="Enlaces de Compra">
            <div style={{ width: "60vh" }}>
              <span className="p-float-label mt-5">
                <InputTextarea
                  name="Link"
                  value={values.Link}
                  onChange={handleInputChange}
                  cols={100}
                  rows={3}
                  className={classNames(" block", "encabezado__contenido")}
                  style={{
                    width: "100%",
                    maxHeight: "4.5rem",
                    maxWidth: "72vh",
                    height: "3rem",
                  }}
                />
                <label htmlFor="Link">Enlace de Compra</label>
                {error.Link && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 1 }}
                  >
                    Campo requerido.
                  </small>
                )}
              </span>

              <span className="p-float-label mt-3 mb-2">
                <InputTextarea
                  name="Description"
                  value={values.Description}
                  onChange={handleInputChange}
                  cols={100}
                  rows={3}
                  className={classNames(" block", "encabezado__contenido")}
                  style={{
                    width: "100%",
                    maxHeight: "4.5rem",
                    maxWidth: "72vh",
                    height: "3rem",
                  }}
                />
                <label htmlFor="Descripcion">Descripción</label>
              </span>

              {activeIndex === 1 && DialogFooter}
            </div>

            <div style={{ maxHeight: "29vh", overflowY: "auto" }}>
              {links?.map((link, index) => (
                <div key={index} className="card mt-2">
                  <div
                    className="card-body"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <p className="card-title">{link.Description}</p>
                      <a
                        href={link.Link}
                        className="btn btn-primary"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Abrir enlace de Compra
                      </a>
                    </div>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDelete(link.IdLink)}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </TabPanel>
        </TabView>
        <Toast ref={toast} />
      </Dialog>
    </div>
  );
};

export default ArchivosRequisicion;
